import Tooltip from 'apollo-react/components/Tooltip';
import Typography from 'apollo-react/components/Typography';
import React from 'react';
import { useSelector } from 'react-redux';

import ReadOnlyInputControl from './ReadOnlyInputControl';
import LazyText from '../../components/LazyText';
import { useFormSelector } from '../../custom-hooks';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getIsRtlLanguage } from '../../selectors/AuthSelectors';
import { getUITA } from '../../utils/commonUtils';
import { isNilOrEmpty } from '../../utils/ramdaUtils';
import { FORM_MODEL_ATTRIBUTES, SS_CONTROL_TYPE } from '../constants/form-manager.constants';
import { getIsFormChangesMode } from '../selectors/common.selectors';
import { getEvaluatedExpression, getTextViewValue } from '../selectors/form-manager.selectors';
import { getDataByController } from '../selectors/runtime.selectors';

const TextView = ({
  inTable,
  label,
  fieldName,
  entityName,
  className,
  isDetail = false,
  index,
  id,
  textBoxPropsJson,
  isEditor,
  formatType,
  url,
  linkType,
  isOnline,
}) => {
  const translateString = useTranslation();
  const isFormChangesMode = useFormSelector(getIsFormChangesMode);
  const value = useFormSelector(getDataByController, { entityName, fieldName, index });
  const renderValue = useFormSelector(getTextViewValue, {
    dataMember: entityName,
    dataField: fieldName,
    value,
    id,
    index,
    formatType,
    prop: FORM_MODEL_ATTRIBUTES.TRANSLATE_DATA,
    controlType: SS_CONTROL_TYPE.TEXT_VIEW,
    translateString,
  });
  const isRtlLanguage = useSelector(getIsRtlLanguage);

  const { isTextBoxViewOnly } = JSON.parse(textBoxPropsJson ?? '{}');
  const hasLabel = !inTable && label && (isDetail || isTextBoxViewOnly || !textBoxPropsJson);
  const hasLink = !isNilOrEmpty(url);
  const uita = getUITA('SSTextView', entityName, fieldName);
  const defaultValue = !isEditor && !isFormChangesMode ? '' : label ?? translateString(fieldName);

  if (hasLabel || hasLink) {
    return (
      <ReadOnlyInputControl
        label={label}
        value={renderValue}
        uita={uita}
        inTable={inTable}
        entityName={entityName}
        fieldName={fieldName}
        controlType={SS_CONTROL_TYPE.TEXT_VIEW}
        isEditor={isEditor}
        id={id}
        index={index}
        url={url}
        linkType={linkType}
        isOnline={isOnline}
      />
    );
  }

  return (
    <div
      style={{ display: 'flex', flex: '1 1 100%', padding: isRtlLanguage && '0px 8px' }}
      ui-ta={uita}
    >
      <LazyText text={isNilOrEmpty(renderValue) ? defaultValue : renderValue}>
        <Typography style={{ flex: 1 }} variant="body2" className={className}>
          {isNilOrEmpty(renderValue) ? defaultValue : renderValue}
        </Typography>
      </LazyText>
    </div>
  );
};

function SSTextView(props) {
  const { id, index, entityName } = props;
  const dataToolTip = useFormSelector(getEvaluatedExpression, {
    id,
    index,
    entityName,
    prop: FORM_MODEL_ATTRIBUTES.DATA_TOOLTIP,
  });

  return dataToolTip ? (
    <Tooltip variant="light" title={dataToolTip} placement="bottom">
      <TextView {...props} />
    </Tooltip>
  ) : (
    <TextView {...props} />
  );
}

export default SSTextView;
